import { render, staticRenderFns } from "./AddEvent.vue?vue&type=template&id=292e08d8&scoped=true"
import script from "./AddEvent.vue?vue&type=script&lang=js"
export * from "./AddEvent.vue?vue&type=script&lang=js"
import style0 from "./AddEvent.vue?vue&type=style&index=0&id=292e08d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292e08d8",
  null
  
)

export default component.exports